<script lang="ts">
    
    import type { Map as Mapgl } from 'mapbox-gl';
    import { createEventDispatcher, getContext, onDestroy } from "svelte";
    import type { Writable } from 'svelte/store';
    import type { LonLat } from "../global";
    import { randomIdGenerator } from '../Services';

    const map: Writable<Mapgl> = getContext('map');
    const dataId = randomIdGenerator.createRandomId();
    const symbolLayerId = `${dataId}-symbol`;
    const dispatch = createEventDispatcher();

    let isDraw = false;

    export let path: LonLat[];
    export let color: string = '#000';
    export let width: number = 3;
    export let text: string = undefined;
    export let opacity: number = 1;
    export let drawBefore: string = undefined;

    $: drawPath($map, path, color, width, text, opacity);
    $: if ($map) {
        $map.on('click', dataId, onClick);
        $map.on('click', symbolLayerId, onClick);
    }

    onDestroy(() => {
        clearPath($map);
        if ($map) {
            $map.off('click', dataId, onClick);
            $map.off('click', symbolLayerId, onClick);
        }
    });

    function onClick() {
        dispatch('click');
    }

    function drawPath(map: Mapgl, path: LonLat[], color: string, width: number, text: string, opacity: number): void {
        
        clearPath(map);

        if (!map || !path) {
            return;
        }

        const pathGeojson: GeoJSON.Feature<GeoJSON.Geometry> = {
            type: 'Feature',
            geometry: {
                type: 'LineString',
                coordinates: path,
            },
            properties: {}
        };

        const pathLayer: mapboxgl.AnyLayer = {
            id: dataId,
            source: dataId,
            type: 'line',
            paint: {
                'line-color': color,
                'line-width': width,
                'line-opacity': opacity,
            }
        };

        map.addSource(dataId, {
            type: 'geojson',
            data: pathGeojson
        });

        map.addLayer(pathLayer);

        if (text) {
            map.addLayer({
                "id": symbolLayerId,
                "type": "symbol",
                "source": dataId,
                "layout": {
                    "symbol-placement": "line",
                    "text-font": ["Open Sans Regular"],
                    "text-field": text,
                    "text-letter-spacing": 0.05,
                    "text-size": 12,
                    "text-offset": [0, -0.7],
                },
                "paint": {
                    "text-color": color,
                    "text-opacity": opacity,
                }
            } as mapboxgl.SymbolLayer, drawBefore);
        }

        isDraw = true;
    }

    function clearPath(map: Mapgl) {
        if (!map || !isDraw) {
            return;
        }
        map.removeLayer(dataId);
        if (map.getLayer(symbolLayerId)) {
            map.removeLayer(symbolLayerId);
        }
        map.removeSource(dataId);
        isDraw = false;
    }

</script>